<template>
  <input
    ref="input"
    :type="type"
    :placeholder="placeholder"
    :disabled="disabled"
    :class="className"
  />
</template>

<script>
import IMask from 'imask'

export default {
  name: 'MaskInput',
  props: {
    modelValue: [String, Number],
    mask: {
      type: [String, Object],
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      maskRef: null,
    }
  },
  mounted() {
    this.initMask()
  },
  watch: {
    modelValue(newVal) {
      if (this.maskRef && this.maskRef.value !== newVal) {
        this.maskRef.value = newVal
      }
    },
    mask(newMask) {
      this.destroyMask()
      this.initMask()
    },
  },
  beforeUnmount() {
    this.destroyMask()
  },
  methods: {
    initMask() {
      if (this.$refs.input) {
        this.maskRef = IMask(this.$refs.input, {
          mask: this.mask,
          definitions: {
            '#': /[0-9]/, // 👈 define que # é um número
          },
        })

        this.maskRef.on('accept', () => {
          this.$emit('update:modelValue', this.maskRef.value)
        })

        if (this.modelValue) {
          this.maskRef.value = this.modelValue
        }
      }
    },
    destroyMask() {
      if (this.maskRef) {
        this.maskRef.destroy()
        this.maskRef = null
      }
    },
  },
}
</script>
